import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPt = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 10,
		height: 24,
		fill: "#006600"
	}), /* @__PURE__ */ _jsx("rect", {
		x: 10,
		width: 14,
		height: 24,
		fill: "#FF0000"
	})]
});
export default SvgPt;
